import { render, staticRenderFns } from "./UpdateProfileName.vue?vue&type=template&id=5cde65a0&scoped=true&"
import script from "./UpdateProfileName.vue?vue&type=script&lang=js&"
export * from "./UpdateProfileName.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProfileName.vue?vue&type=style&index=0&id=5cde65a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde65a0",
  null
  
)

export default component.exports